import { ExtraFeatureTypes } from "@/lib/priceCalculator/types/orderForm";

export const extraFeaturesImages: any = {
  [ExtraFeatureTypes.ExtraQualityCheck]: "extra-quality-control",
  [ExtraFeatureTypes.PremiumWriter]: "premium-writer",
  [ExtraFeatureTypes.OriginalityReport]: "originality-report",
  [ExtraFeatureTypes.DraftFeature]: "draft-feature",
  [ExtraFeatureTypes.AIReport]: "ai-check",
};
